import { render, staticRenderFns } from "./InfiniteLoading.vue?vue&type=template&id=11bff340&scoped=true"
import script from "./InfiniteLoading.vue?vue&type=script&lang=js"
export * from "./InfiniteLoading.vue?vue&type=script&lang=js"
import style0 from "./InfiniteLoading.vue?vue&type=style&index=0&id=11bff340&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bff340",
  null
  
)

export default component.exports